import Icon from '../components/Icon.vue'

Icon.register({"share":{"width":1792,"height":1792,"paths":[{"d":"M1792 640q0 26-19 45l-512 512q-19 19-45 19t-45-19-19-45v-256h-224q-98 0-175.5 6t-154 21.5-133 42.5-105.5 69.5-80 101-48.5 138.5-17.5 181q0 55 5 123 0 6 2.5 23.5t2.5 26.5q0 15-8.5 25t-23.5 10q-16 0-28-17-7-9-13-22t-13.5-30-10.5-24q-127-285-127-451 0-199 53-333 162-403 875-403h224v-256q0-26 19-45t45-19 45 19l512 512q19 19 19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share.js
// module id = 1694
// module chunks = 0